import EditOrder from "./EditOrder"

export default  EditOrder;



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/OrdersTable/EditOrder/index.js